// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CallAsk,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  caller: __t.identity(),
  partyId: __t.u64().name("party_id"),
  fromParty: __t.u64().name("from_party"),
  kind: __t.u8(),
  offerId: __t.u64().name("offer_id"),
  villageId: __t.u64().name("village_id"),
  get asks() {
    return __t.array(CallAsk);
  },
  deadline: __t.timestamp(),
  state: __t.u8(),
  note: __t.string(),
  at: __t.timestamp(),
});
